import TeamMember from "../../js/components/team-member";

export default ({ team, setModifyMember }) => {
    return (
        <div class="myteam__members">
            { team.map((data, index) => <TeamMember key={index} data={data} onClick={() => setModifyMember(data)}/>) } 
        </div>
    )
}